<template>
    <el-drawer
        :title="isEdit ? '编辑课程' : '添加课程'"
        :visible.sync="drawer"
        :modal="true"
        :wrapperClosable="false"
        size="600px"
        @close="closeDrawer"
        :modal-append-to-body="false"
        :direction="direction">

        <!-- title -->
        <div class="drawer_form">
            
            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="120px" class="demo-ruleForm">
                
                <div class="form-body">
                    <overlay-scrollbars style="width: 100%;height: 100%;" class="el-fade-in">
                        <el-form-item label="课程代码" prop="code">
                            <el-input type="text" v-model="form.code" autocomplete="off" placeholder="请输入课程代码"></el-input>
                        </el-form-item>
                        <el-form-item label="课程名称" prop="name">
                            <el-input type="text" v-model="form.name" autocomplete="off" placeholder="请输入课程名称"></el-input>
                        </el-form-item>
                        <el-form-item label="课程描述" prop="description">
                            <el-input type="textarea" rows="4" v-model="form.description" autocomplete="off" placeholder="请输入课程描述"></el-input>
                        </el-form-item>
                    </overlay-scrollbars>
                </div>

                <div class="form-foot d-flex a-center j-center">
                    <el-button @click="onSubmit" class="common-button">{{ isEdit ? '保存' : '添加' }}</el-button>
                </div>
            </el-form>
        </div>

    </el-drawer>
    
</template>

<script>
import { save, get_course } from '@/request/api/course.js'
export default {
    data() {
        return {
            drawer: true,
            direction: 'rtl',
            loading: false,
            isEdit: false,
            form: {
                id: '',
                code: '',
                name: '',
                description: '',
            },
            rules: {
                code: [
                    { required: true, message: '请输入课程代码', trigger: 'blur' },
                ],
                name: [
                    { required: true, message: '请输入课程名称', trigger: 'blur' },
                ],
            },
        }
    },
    created() {
        this.isEdit = !!this.$route.query.id
        this.form.id = this.$route.query.id || ''
        if (this.isEdit) {
            this.loadData()
        }
    },
    methods: {
        loadData() {
            get_course({ id: this.form.id }).then(res => {
                if (!res.data) return console.error("res.data is null")
                Object.keys(this.form).forEach(item => {
                    if (res.data[item] !== undefined) {
                        this.form[item] = res.data[item]
                    }
                })
            })
        },
        onSubmit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.req()
                } else {
                    return false
                }
            })
        },
        req() {
            const submitData = { ...this.form }
            // 新增时不传id（后端根据id是否为空判断新增/修改）
            if (!this.isEdit) {
                delete submitData.id
            }
            save(submitData).then(res => {
                if (res.code != 0) return this.$notify.error({ title: '错误', message: res.msg })
                this.$notify({ title: '成功', message: res.msg, type: 'success' })
                this.$router.go(-1)
            })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields()
        },
        closeDrawer() {
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="less" scoped>
.drawer_form {
    width: 96%;
    margin: auto;
    .drawer_form_title {
        color: #17233d;
        font-size: 22px;
        font-weight: 400;
        text-align: center;
        line-height: 48px;
        margin-bottom: 20px;
    }
    .drawer_line {
        margin-bottom: 30px;
        .drawer_line_text {
            width: 120px;
            margin-right: 20px;
            text-align: right;
            color: #515a6e;
        }    
    }
}
.form-items {
    background-color: #f5f6fb;
    padding: 15px 10px;
    height: 500px;
}

/deep/ .form-items .el-form-item,
/deep/ .form-items .el-form-item .el-form-item__content {
    width: 100%;
}
</style>
